import { memo } from 'react';
import { Separator as RACSeparator, SeparatorProps as RACSeparatorProps } from 'react-aria-components';

import { ComponentContextProps, merge, useComponent } from '@/components';

export type SeparatorProps = RACSeparatorProps & Partial<ComponentContextProps>;

const ISeparator = ({ variant, orientation, className, ...rest }: SeparatorProps) => {
  const context = useComponent({ variant });

  /* prettier-ignore */
  const styles = [
    'border-none',
  ];

  /* prettier-ignore */
  const plainStyles = [
    'bg-gray-200',
  ];

  /* prettier-ignore */
  const primaryStyles = [
    'bg-primary-100',
  ];

  /* prettier-ignore */
  const secondaryStyles = [
    'bg-gray-200',
  ];

  /* prettier-ignore */
  const successStyles = [
    'bg-success-100',
  ];

  /* prettier-ignore */
  const warningStyles = [
    'bg-warning-100',
  ];

  /* prettier-ignore */
  const errorStyles = [
    'bg-error-100',
  ];

  /* prettier-ignore */
  const horizontalStyles= [
    'h-[1px]',
    'w-full',
  ];

  /* prettier-ignore */
  const verticalStyles= [
    'w-[1px]',
    /* Height is 0 in flex containers (sometimes?) */
    'h-full',
  ];

  return (
    <RACSeparator
      className={merge(
        styles,
        context.variant === 'default' && plainStyles,
        context.variant === 'plain' && plainStyles,
        context.variant === 'primary' && primaryStyles,
        context.variant === 'secondary' && secondaryStyles,
        context.variant === 'success' && successStyles,
        context.variant === 'warning' && warningStyles,
        context.variant === 'error' && errorStyles,
        orientation === 'horizontal' && horizontalStyles,
        orientation === 'vertical' && verticalStyles,
        className
      )}
      orientation={orientation}
      {...rest}
    />
  );
};

export const Separator = memo(ISeparator) as typeof ISeparator;
